import React from 'react';
import { CheckCircleIcon, ClockIcon, PhoneIcon, MapPinIcon, FileTextIcon, ListChecksIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function WhatYouGetSection() {
  return <section className="w-full bg-white" aria-label="Qué incluye" data-id="element-240">
      <div className="max-w-3xl mx-auto px-5 py-16 md:py-24" data-id="element-241">
        <p className="text-center text-[#C41E3A] font-semibold text-lg mb-3 tracking-wide uppercase" data-id="element-242">
          Presentando
        </p>
        <h2 className="text-3xl md:text-5xl font-bold text-[#1B2A4A] text-center leading-tight mb-4" data-id="element-243">
          SOS Muela — Protocolo de 48 Horas
        </h2>
        <p className="text-xl text-center text-gray-600 mb-4" data-id="element-244">(Sin Pánico)</p>
        <p className="text-lg text-center text-gray-700 max-w-xl mx-auto mb-12" data-id="element-245">
          No te promete "curarte la muela". Te promete algo más útil hoy:{' '}
          <strong className="text-[#1B2A4A]" data-id="element-246">Pasar de pánico a control.</strong>
        </p>

        {/* What's Inside */}
        <div className="space-y-5 mb-12" data-id="element-247">
          <div className="flex items-start gap-4 bg-gray-50 rounded-xl p-5" data-id="element-248">
            <div className="w-10 h-10 rounded-lg bg-[#10B981]/10 flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-249">
              <CheckCircleIcon className="w-5 h-5 text-[#10B981]" aria-hidden="true" data-id="element-250" />
            </div>
            <div data-id="element-251">
              <h3 className="text-lg font-bold text-[#1B2A4A] mb-1" data-id="element-252">
                Semáforo de Triage (Verde/Amarillo/Rojo)
              </h3>
              <p className="text-gray-600" data-id="element-253">
                Para decidir rápido si puedes manejar temporalmente o si es
                urgente.
              </p>
            </div>
          </div>

          <div className="flex items-start gap-4 bg-gray-50 rounded-xl p-5" data-id="element-254">
            <div className="w-10 h-10 rounded-lg bg-[#10B981]/10 flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-255">
              <ClockIcon className="w-5 h-5 text-[#10B981]" aria-hidden="true" data-id="element-256" />
            </div>
            <div data-id="element-257">
              <h3 className="text-lg font-bold text-[#1B2A4A] mb-1" data-id="element-258">
                Primeros 30 minutos
              </h3>
              <p className="text-gray-600" data-id="element-259">
                Qué hacer ahora mismo para bajar intensidad sin meterte en
                errores comunes.
              </p>
            </div>
          </div>

          <div className="flex items-start gap-4 bg-gray-50 rounded-xl p-5" data-id="element-260">
            <div className="w-10 h-10 rounded-lg bg-[#EF4444]/10 flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-261">
              <ListChecksIcon className="w-5 h-5 text-[#EF4444]" aria-hidden="true" data-id="element-262" />
            </div>
            <div data-id="element-263">
              <h3 className="text-lg font-bold text-[#1B2A4A] mb-1" data-id="element-264">
                Las 8 banderas rojas
              </h3>
              <p className="text-gray-600" data-id="element-265">
                Señales que cambian todo (para no quedarte adivinando).
              </p>
            </div>
          </div>

          <div className="flex items-start gap-4 bg-gray-50 rounded-xl p-5" data-id="element-266">
            <div className="w-10 h-10 rounded-lg bg-[#1B2A4A]/10 flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-267">
              <MapPinIcon className="w-5 h-5 text-[#1B2A4A]" aria-hidden="true" data-id="element-268" />
            </div>
            <div data-id="element-269">
              <h3 className="text-lg font-bold text-[#1B2A4A] mb-1" data-id="element-270">
                Ruta de atención en USA
              </h3>
              <p className="text-gray-600" data-id="element-271">
                Dentista de emergencia vs urgent care vs ER — qué esperar de
                cada uno.
              </p>
            </div>
          </div>

          <div className="flex items-start gap-4 bg-gray-50 rounded-xl p-5" data-id="element-272">
            <div className="w-10 h-10 rounded-lg bg-[#F59E0B]/10 flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-273">
              <PhoneIcon className="w-5 h-5 text-[#F59E0B]" aria-hidden="true" data-id="element-274" />
            </div>
            <div data-id="element-275">
              <h3 className="text-lg font-bold text-[#1B2A4A] mb-1" data-id="element-276">
                Guiones para llamar
              </h3>
              <p className="text-gray-600" data-id="element-277">
                Palabras exactas para pedir cita de emergencia, lista de
                cancelaciones y recomendaciones.
              </p>
            </div>
          </div>

          <div className="flex items-start gap-4 bg-gray-50 rounded-xl p-5" data-id="element-278">
            <div className="w-10 h-10 rounded-lg bg-[#1B2A4A]/10 flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-279">
              <FileTextIcon className="w-5 h-5 text-[#1B2A4A]" aria-hidden="true" data-id="element-280" />
            </div>
            <div data-id="element-281">
              <h3 className="text-lg font-bold text-[#1B2A4A] mb-1" data-id="element-282">
                Plan de 48 horas
              </h3>
              <p className="text-gray-600" data-id="element-283">
                Una agenda simple para Noche 1 → Día 1 → Noche 2.
              </p>
            </div>
          </div>
        </div>

        {/* Bonuses */}
        <div className="bg-[#1B2A4A] rounded-2xl p-6 md:p-8 text-white mb-12" data-id="element-284">
          <p className="text-[#F59E0B] font-semibold text-sm uppercase tracking-wider mb-4" data-id="element-285">
            Y además incluye:
          </p>
          <div className="space-y-4" data-id="element-286">
            <div className="flex items-start gap-3" data-id="element-287">
              <CheckCircleIcon className="w-5 h-5 text-[#10B981] mt-1 flex-shrink-0" aria-hidden="true" data-id="element-288" />
              <p className="text-lg" data-id="element-289">
                <strong data-id="element-290">Checklist imprimible "Noche de dolor"</strong> — para
                tener al lado de la cama.
              </p>
            </div>
            <div className="flex items-start gap-3" data-id="element-291">
              <CheckCircleIcon className="w-5 h-5 text-[#10B981] mt-1 flex-shrink-0" aria-hidden="true" data-id="element-292" />
              <p className="text-lg" data-id="element-293">
                <strong data-id="element-294">Tarjeta de síntomas para llevar a la cita</strong> —
                para que te tomen en serio y no se te olvide nada.
              </p>
            </div>
          </div>
        </div>

        {/* Image */}
        <div className="flex justify-center mb-12" data-id="element-295">
          <img src="https://cdn.magicpatterns.com/uploads/uzajHTYkqsKqb27c91wat2/SOS_muela_sillon.jpg" alt="Mujer leyendo la guía SOS Muela cómodamente en su sofá" className="w-full max-w-md rounded-2xl shadow-lg" data-id="element-296" />
        </div>

        <CTAButton text="Quiero Mi Protocolo" subtitle="Acceso inmediato después del pago." href="#precio" data-id="element-297" />
      </div>
    </section>;
}